import { RequireOnly } from '@pelicargo/types';
import { modelUtils } from '@pelicargo/utils';
import { Cargo, DimensionUnit } from '@prisma/client';

export const summaryLines = (
  cargos: RequireOnly<Cargo, 'quantity' | 'length' | 'width' | 'height' | 'weight' | 'handling'>[] | null | undefined,
  dimensionUnit?: DimensionUnit,
) => (cargos ?? []).map((cargo) => modelUtils.cargo.summaryLine(cargo, dimensionUnit)).join('\n');
